/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactors_Limitedbody3Inputs */

const id_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami hanya menggunakan jumlah data yang diperlukan untuk memberikan informasi yang berarti tanpa menggantikan karya asli.`)
};

const ms_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami hanya menggunakan jumlah data yang diperlukan untuk memberikan maklumat yang bermakna tanpa menggantikan karya asal.`)
};

const da_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruger kun den nødvendige mængde data til at give meningsfuld information uden at erstatte de originale værker.`)
};

const de_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden nur die notwendige Datenmenge, um aussagekräftige Informationen zu liefern, ohne die Originalwerke zu ersetzen.`)
};

const en_us2_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use only the necessary amount of data to provide meaningful information without replacing the original works.`)
};

const es_es2_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos solo la cantidad necesaria de datos para proporcionar información significativa sin reemplazar las obras originales.`)
};

const es_mx2_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos solo la cantidad necesaria de datos para proporcionar información significativa sin reemplazar las obras originales.`)
};

const fil_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginagamit lamang namin ang kinakailangang dami ng datos upang magbigay ng makabuluhang impormasyon nang hindi pinapalitan ang orihinal na mga gawa.`)
};

const fr_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons uniquement la quantité de données nécessaire pour fournir des informations pertinentes sans remplacer les œuvres originales.`)
};

const it_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizziamo solo la quantità necessaria di dati per fornire informazioni significative senza sostituire le opere originali.`)
};

const hu_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak a szükséges mennyiségű adatot használjuk fel, hogy értelmes információt nyújtsunk anélkül, hogy helyettesítenénk az eredeti műveket.`)
};

const nl_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken alleen de benodigde hoeveelheid gegevens om zinvolle informatie te verstrekken zonder de originele werken te vervangen.`)
};

const no_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bruker bare den nødvendige mengden data for å gi meningsfull informasjon uten å erstatte de opprinnelige verkene.`)
};

const pl_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używamy tylko niezbędnej ilości danych, aby dostarczyć wartościowych informacji bez zastępowania oryginalnych dzieł.`)
};

const pt_br2_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos apenas a quantidade necessária de dados para fornecer informações significativas sem substituir os trabalhos originais.`)
};

const pt_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos apenas a quantidade necessária de dados para fornecer informações significativas sem substituir as obras originais.`)
};

const ro_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folosim doar cantitatea necesară de date pentru a oferi informații semnificative fără a înlocui operele originale.`)
};

const fi_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytämme vain tarvittavan määrän tietoa tarjotaksemme merkityksellistä tietoa korvaamatta alkuperäisiä teoksia.`)
};

const sv_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi använder endast den mängd data som krävs för att tillhandahålla meningsfull information utan att ersätta originalverken.`)
};

const vi_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi chỉ sử dụng lượng dữ liệu cần thiết để cung cấp thông tin hữu ích mà không thay thế các tác phẩm gốc.`)
};

const tr_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orijinal çalışmaların yerini almadan anlamlı bilgi sağlamak için yalnızca gerekli miktarda veri kullanıyoruz.`)
};

const cs_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Používáme pouze nezbytné množství dat k poskytnutí smysluplných informací, aniž bychom nahrazovali původní díla.`)
};

const bg_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ние използваме само необходимото количество данни, за да предоставим смислена информация, без да заместваме оригиналните произведения.`)
};

const ru_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы используем только необходимый объём данных для предоставления значимой информации, не заменяя оригинальные источники.`)
};

const uk_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми використовуємо лише необхідний обсяг даних для надання значущої інформації, не замінюючи оригінальні твори.`)
};

const ar_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نستخدم فقط الكمية الضرورية من البيانات لتوفير معلومات مفيدة دون استبدال الأعمال الأصلية.`)
};

const hi_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम मूल कार्यों को प्रतिस्थापित किए बिना सार्थक जानकारी प्रदान करने के लिए केवल आवश्यक डेटा का उपयोग करते हैं।`)
};

const th_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราใช้ข้อมูลในปริมาณที่จำเป็นเพื่อให้ข้อมูลที่มีความหมายโดยไม่แทนที่ผลงานต้นฉบับ`)
};

const ja_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナル作品を代替することなく、有意義な情報を提供するために必要な量のデータのみを使用しています。`)
};

const zh_cn2_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们仅使用提供有意义信息所需的必要数据量，而不会取代原作。`)
};

const zh_hant1_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們僅使用提供有意義資訊所需的必要資料量，而不會取代原作。`)
};

const ko_about_fairusefactors_limitedbody3 = /** @type {(inputs: About_Fairusefactors_Limitedbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원저작물을 대체하지 않고 의미 있는 정보를 제공하는 데 필요한 최소한의 데이터만 사용합니다.`)
};

/**
* | output |
* | --- |
* | "We use only the necessary amount of data to provide meaningful information without replacing the original works." |
*
* @param {About_Fairusefactors_Limitedbody3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactors_limitedbody3 = /** @type {((inputs?: About_Fairusefactors_Limitedbody3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactors_Limitedbody3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactors_limitedbody3(inputs)
	if (locale === "ms") return ms_about_fairusefactors_limitedbody3(inputs)
	if (locale === "da") return da_about_fairusefactors_limitedbody3(inputs)
	if (locale === "de") return de_about_fairusefactors_limitedbody3(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactors_limitedbody3(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactors_limitedbody3(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactors_limitedbody3(inputs)
	if (locale === "fil") return fil_about_fairusefactors_limitedbody3(inputs)
	if (locale === "fr") return fr_about_fairusefactors_limitedbody3(inputs)
	if (locale === "it") return it_about_fairusefactors_limitedbody3(inputs)
	if (locale === "hu") return hu_about_fairusefactors_limitedbody3(inputs)
	if (locale === "nl") return nl_about_fairusefactors_limitedbody3(inputs)
	if (locale === "no") return no_about_fairusefactors_limitedbody3(inputs)
	if (locale === "pl") return pl_about_fairusefactors_limitedbody3(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactors_limitedbody3(inputs)
	if (locale === "pt") return pt_about_fairusefactors_limitedbody3(inputs)
	if (locale === "ro") return ro_about_fairusefactors_limitedbody3(inputs)
	if (locale === "fi") return fi_about_fairusefactors_limitedbody3(inputs)
	if (locale === "sv") return sv_about_fairusefactors_limitedbody3(inputs)
	if (locale === "vi") return vi_about_fairusefactors_limitedbody3(inputs)
	if (locale === "tr") return tr_about_fairusefactors_limitedbody3(inputs)
	if (locale === "cs") return cs_about_fairusefactors_limitedbody3(inputs)
	if (locale === "bg") return bg_about_fairusefactors_limitedbody3(inputs)
	if (locale === "ru") return ru_about_fairusefactors_limitedbody3(inputs)
	if (locale === "uk") return uk_about_fairusefactors_limitedbody3(inputs)
	if (locale === "ar") return ar_about_fairusefactors_limitedbody3(inputs)
	if (locale === "hi") return hi_about_fairusefactors_limitedbody3(inputs)
	if (locale === "th") return th_about_fairusefactors_limitedbody3(inputs)
	if (locale === "ja") return ja_about_fairusefactors_limitedbody3(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactors_limitedbody3(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactors_limitedbody3(inputs)
	return ko_about_fairusefactors_limitedbody3(inputs)
});
export { about_fairusefactors_limitedbody3 as "about.fairUseFactors.limitedBody" }